module.exports = __webpack_public_path__ + "assets/img/edit_hover.eabccb00.svg";